import { V2024, V2025 } from '@models/Version'
import { SectionComponentClass } from '@sections/SectionComponent'
import { Store } from '@stores/Store'
import { simulatorPageSection } from '@utils/sections/Section.util'
import { simulatorPageSection2024 } from '@utils/sections/v2024/Section.util'

export class VersionHelper {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Helper

  get version2024(): boolean {
    const { versionYear } = this.store.globalStore
    return versionYear === V2024
  }

  get version2025(): boolean {
    const { versionYear } = this.store.globalStore
    return versionYear === V2025
  }


  // Pages

  get simulatorPageSection(): SectionComponentClass[] {
    if (this.version2024) { return simulatorPageSection2024() }

    return simulatorPageSection()
  }


  // Calculations
  // Summary Total Income

  get totalIncomeMonthlyAmount() {
    const { store } = this
    const { summaryCalculation, summaryCalculation2024 } = store
    const { totalIncomeMonthlyAmount } = summaryCalculation
    const { totalIncomeMonthlyAmount2024 } = summaryCalculation2024

    if (this.version2024) { return totalIncomeMonthlyAmount2024 }

    return totalIncomeMonthlyAmount
  }

  get totalIncomeAnnualAmount() {
    const { store } = this
    const { summaryCalculation, summaryCalculation2024 } = store
    const { totalIncomeAnnualAmount } = summaryCalculation
    const { totalIncomeAnnualAmount2024 } = summaryCalculation2024

    if (this.version2024) { return totalIncomeAnnualAmount2024 }

    return totalIncomeAnnualAmount
  }

}
